export function getDefaultLineItems(trade) {
  switch (trade) {
    case "Painting":
      return [
        { description: "Paint and labour", amount: 0 },
      ];
    case "Plumbing":
      return [
        { description: "Call-out & diagnosis", amount: 220 },
        { description: "Labour", amount: 280 },
        { description: "Parts & fittings", amount: 180 },
      ];
    case "Electrical":
      return [
        { description: "Call-out & testing", amount: 180 },
        { description: "Labour", amount: 320 },
        { description: "Materials", amount: 240 },
      ];
    case "Solar & Battery":
      return [
        { description: "Solar panels & mounting", amount: 4500 },
        { description: "Inverter", amount: 1200 },
        { description: "Installation labour", amount: 800 },
      ];
    case "Building":
      return [
        { description: "Labour", amount: 15000 },
        { description: "Materials", amount: 8000 },
        { description: "Site preparation", amount: 2000 },
      ];
    case "Carpentry":
      return [
        { description: "Labour", amount: 950 },
        { description: "Materials", amount: 420 },
      ];
    case "Concreter":
      return [
        { description: "Excavation & prep", amount: 800 },
        { description: "Concrete supply", amount: 1200 },
        { description: "Labour & finishing", amount: 950 },
      ];
    case "HVAC":
      return [
        { description: "Unit supply", amount: 1800 },
        { description: "Installation labour", amount: 650 },
        { description: "Electrical connection", amount: 250 },
      ];
    case "Landscaping":
      return [
        { description: "Site preparation", amount: 600 },
        { description: "Labour", amount: 1200 },
        { description: "Materials", amount: 700 },
      ];
    case "Roofing":
      return [
        { description: "Inspection & safety setup", amount: 350 },
        { description: "Labour", amount: 1250 },
        { description: "Materials", amount: 650 },
      ];
    case "Cleaning":
      return [
        { description: "Labour", amount: 350 },
        { description: "Consumables", amount: 60 },
      ];
    case "Handyman":
      return [
        { description: "Call-out", amount: 120 },
        { description: "Labour", amount: 280 },
        { description: "Materials", amount: 90 },
      ];
    default:
      return [{ description: "Labour", amount: 0 }];
  }
}
